module.exports = __webpack_public_path__ + "static/images/jf-ygmb.b1d9a60.png";